import httpManager from "@/app/shared/utils/httpManager";

export async function generateMultipleTtsAudios(strategyId, payload = {}) {
  const response = await httpManager.post(
    `/strategies/${strategyId}/generate-multiple-tts-audios/`,
    payload
  );
  return response?.data;
}
